/* eslint-disable */
<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('products.edit', { itm: "(" + product.name + ")" }) }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent :loading="loading" :disabled="loading" :ClickFun="updateProduct" svg="1"
                :Title="$t('products.save')" />
        </div>
    </div>
    <v-form ref="form" @submit.prevent="updateProduct">
        <v-card v-if="loading" elevation="0">
            <div style="height: 250px; line-height: 250px;">
                <v-progress-circular indeterminate size="50"></v-progress-circular>
            </div>
        </v-card>
        <v-card v-else elevation="0">
            <div class="row ma-4">
                <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.BasicInformations') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('products.supplier') }}<span
                                class="red">*</span></v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete :style="MySupplier ? 'pointer-events: none;' : ''" v-model="product.supplierId"
                            :items="suppliers" item-title="name" item-value="supplierId" persistent-placeholder
                            variant="outlined" :placeholder="$t('placeholder.select', { itm: $t('products.supplier') })"
                            hide-details>
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                        <span class="warningHint" id="WarningMsgCompany">{{ msg.Supplier }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('products.categories') }}<span
                                class="red">*</span></v-card-title>
                    </div>
                    <div class="row">
                        <autocompleteGrouped v-model="product.categories" :items="flattenedCategories"
                            :selectedItems="product.categories"
                            :placeholder="$t('placeholder.select', { itm: $t('products.categories') })" />
                        <span class="warningHint" id="WarningMsgCategories">{{ msg.Categories }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.title') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.name" id="Title" name="Title" maxlength="128" hide-details
                            persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('products.title') })"
                            variant="outlined"></v-text-field>
                        <span class="warningHint" id="WarningMsgTitle">{{ msg.Title }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.price') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.basePrice" id="price" type="number" name="price" maxlength="9"
                            @update:model-value="product.basePrice = product.basePrice.replace(/[^0-9.]/g, '');"
                            hide-details persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('products.price') })" variant="outlined"
                            :suffix="currency"></v-text-field>
                        <span class="warningHint" id="WarningMsgPrice">{{ msg.Price }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('products.mark') }}<span
                                class="red">*</span></v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete v-model="product.marque" :items="marks" item-title="brandName"
                            item-value="brandName" persistent-placeholder variant="outlined"
                            :placeholder="$t('placeholder.select', { itm: $t('products.mark') })" hide-details>
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                        <span class="warningHint" id="WarningMsgMarque">{{ msg.Marque }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.tax') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="product.tax" id="tax" type="number" name="tax" maxlength="5"
                            density="compact" hide-details persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('products.tax') })" variant="outlined"
                            suffix="%"></v-text-field>
                        <span class="warningHint" id="WarningMsgTax">{{ msg.Tax }}</span>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.type') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete v-model="product.productType" :items="productType" item-title="name"
                            item-value="id" persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('products.type') })" variant="outlined"
                            hide-no-data hide-details></v-autocomplete>
                        <span class="warningHint" id="WarningMsgType">{{ msg.Type }}</span>
                    </div>
                </div>

                <div class="col-12 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.description') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-textarea id="Comment" v-model="product.description" variant="outlined"
                            :placeholder="$t('placeholder.enter', { itm: $t('products.description') })" hide-details
                            maxlength="500" rows='5' no-resize></v-textarea>
                        <span class="warningHint" id="WarningMsgDescription">{{ msg.Description }}</span>
                    </div>
                </div>
                <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.tags') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.tags') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <div class="col-4 justify-content-start">
                            <v-autocomplete v-model="newTag" :items="suggestedTags"
                                :append-inner-icon="newTag ? 'mdi-plus' : ''" @click:append-inner="addTag"
                                @keyup.enter="addTag" persistent-placeholder
                                :placeholder="$t('products.PlaceHolderTags')" variant="outlined" v-model:search="newTag"
                                hide-no-data hide-details>
                                <template v-slot:item="{ props, item, index }">
                                    <v-list-item v-bind="props" variant="text" :id="index" :name="item.name"
                                        @click="addTag">
                                        {{ item.name }}
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </div>
                        <div class="col-8 justify-content-center align-items-center align-self-center">
                            <div class="tags-list">
                                <chipsButton v-for="(tag, index) in product.tags" :key="tag" class="ma-1" closable
                                    color="primary" :clickClose="removeTag" :tagIndex="index" :title="tag">
                                </chipsButton>
                                <div v-if="product.tags.length == 0" class="text-caption text-grey pa-2">
                                    {{ $t('products.noTagsAdded') }} </div>
                            </div>
                        </div>
                    </div>
                    <span class="warningHint" id="WarningMsgTags">{{ msg.Tags }}</span>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.options') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row my-2" style="max-width: 500px; justify-self: center;">
                        <v-btn color="primary" variant="outlined" @click="addOption" prepend-icon="mdi-plus">
                            {{ $t('products.addOption') }}
                        </v-btn>
                    </div>
                </div>
                <div class="col-12 justify-content-center">
                    <v-card v-for="(option, optionIndex) in product.options" :key="optionIndex" variant="outlined"
                        class="ma-2 pa-4">
                        <div class="col-12 justify-content-start">
                            <div class="row">
                                <v-card-title class="text-left">
                                    {{ $t('products.optionName') }}<span class="red">*</span>
                                </v-card-title>
                            </div>
                            <div class="row">
                                <v-text-field v-model="option.name" persistent-placeholder hide-details
                                    :placeholder="$t('placeholder.enter', { itm: $t('products.optionName') })"
                                    variant="outlined"></v-text-field>
                                <span class="hint">{{ $t('products.exampleOptions') }}</span>
                            </div>
                        </div>
                        <div class="col-12 justify-content-start">
                            <div class="row">
                                <v-card-title class="text-left">
                                    {{ $t('products.optionValues') }}<span class="red">*</span>
                                </v-card-title>
                            </div>
                            <div class="row">
                                <v-combobox v-model="option.values" persistent-placeholder hide-details
                                    :placeholder="$t('placeholder.enter', { itm: $t('products.optionValues') })"
                                    variant="outlined" multiple chips closable-chips></v-combobox>
                                <span class="hint">{{ $t('products.pressEnterToAddValues') }}</span>
                            </div>
                        </div>

                        <v-btn color="error" variant="text" @click="removeOption(optionIndex)" class="mt-2"
                            prepend-icon="mdi-delete">
                            {{ $t('products.removeOption') }}
                        </v-btn>
                    </v-card>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.variants') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row my-4" style="max-width: 500px; justify-self: center;">
                        <v-btn color="primary" variant="outlined" @click="generateVariants" prepend-icon="mdi-refresh"
                            :disabled="!hasValidOptions">
                            {{ $t('products.generateVariants') }}
                        </v-btn>
                    </div>

                    <v-card v-if="product.variants.length" variant="outlined">
                        <v-table>
                            <thead>
                                <tr>
                                    <th class="text-center" v-if="variantWarning.length > 0"></th>
                                    <th class="text-center">{{ $t('products.variant') }}</th>
                                    <th class="text-center">{{ $t('products.price') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.quantityMin') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.collectionTimePerHour') }} <span class="red">*</span></th>
                                    <th class="text-center">{{ $t('products.inventory') }}</th>
                                    <th class="text-center">{{ $t('products.manageInventory') }}</th>
                                    <th class="text-center">{{ $t('products.actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(variant, index) in product.variants" :key="variant.id || index">
                                    <td v-if="variantWarning.length > 0">
                                        <span v-if="variantWarning.includes(index)" class="mdi mdi-alert-circle-outline"
                                            style="color: red; font-size: 20px;"></span>
                                    </td>
                                    <td>{{ getVariantTitle(variant) }}</td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.priceAdjustment" type="number"
                                            density="compact" hide-details :suffix="currency" variant="outlined" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.quantityMinCommanded" type="number"
                                            density="compact" hide-details variant="outlined" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.collectionTimePerHour" type="number"
                                            :min="0" density="compact" hide-details suffix="H" variant="outlined"
                                            @update:model-value="variant.collectionTimePerHour = Math.max(0, Number($event))" />
                                    </td>
                                    <td style="width: 150px">
                                        <v-text-field v-model.number="variant.stock" type="number" density="compact"
                                            hide-details variant="outlined" :disabled="!variant.manage_inventory" />
                                    </td>
                                    <td class="text-center" style="width: 100px">
                                        <v-switch v-model="variant.manage_inventory" density="compact" color="primary"
                                            hide-details class="ma-0 pa-0" />
                                    </td>
                                    <td class="text-center" style="width: 100px">
                                        <v-btn icon="mdi-delete" variant="text" color="error" size="small"
                                            @click="removeVariant(index)" />
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card>
                    <v-card v-else variant="outlined" class="pa-4 text-center text-grey">
                        {{ $t('products.noVariantsMessage') }}
                    </v-card>
                    <span class="warningHint" id="WarningMsgVariants">{{ msg.Variants }}</span>
                </div>
                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.images') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.images') }}<span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row" style="max-width: 500px; justify-self: center;">
                        <uploadMultiDocument v-on:addMultiDocument="setProductImages" :showUpload="true"
                            :fileTypes="fileTypes" subTitle='products.uploadImageHint'>
                            <template v-slot:DocumentsList>
                                <div style="max-height: 60px; overflow-y:scroll; overflow-x: hidden;">
                                    <div v-for="(fileName, index) in MultiFileList" :key="index">
                                        <div @mouseover="setHover(index)" @mouseout="setHover(null)"
                                            style="display: flex; position: relative;">
                                            <span
                                                style="color: blue; cursor: pointer; text-align: start; max-width: 95%;"
                                                :title="fileName">{{ fileName
                                                }}</span>
                                            <!-- <v-icon v-show="isHovered == index"
                                                @click="showDeleteConfirmationDialog(fileName, index)" class="ml-2"
                                                style="color: red">mdi-close-circle-outline</v-icon> -->
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </uploadMultiDocument>
                        <span class="warningHint" id="WarningMsgImages">{{ msg.Images }}</span>
                    </div>
                </div>

                <v-row class="mt-5">
                    <v-col v-for="(preview, index) in imagePreviews" :key="index" cols="12" sm="6" md="4" lg="3">
                        <v-card class="mx-auto">
                            <v-img :src="preview.url" height="200" class="bg-grey-lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey-lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                            <v-icon @click="removeImage(index)" class="ml-2"
                                style="color: red">mdi-close-circle-outline</v-icon>
                        </v-card>
                    </v-col>
                </v-row>

                <v-tabs class="mt-4" v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                    <v-tab class="slider" value="option-1" centered v-model="general" style="pointer-events: none;">
                        {{ $t('products.video') }}
                    </v-tab>
                </v-tabs>
                <v-divider class="mb-4"></v-divider>
                <div class="col-12 justify-content-center">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('products.video') }}
                        </v-card-title>
                    </div>
                    <div v-if="!videoPreviews[0]" class="row" style="max-width: 500px; justify-self: center;">
                        <uploadVideo v-on:addVideo="setProductVideo" :showUpload="true"
                            subTitle='products.uploadVideoHint'>
                            <template v-slot:DocumentsList>
                                <div style="max-height: 60px; overflow-y:scroll; overflow-x: hidden;">
                                    <div v-for="(fileName, index) in MultiFileList" :key="index">
                                        <div @mouseover="setHover(index)" @mouseout="setHover(null)"
                                            style="display: flex; position: relative;">
                                            <span
                                                style="color: blue; cursor: pointer; text-align: start; max-width: 95%;"
                                                :title="fileName">{{ fileName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </uploadVideo>
                        <span class="warningHint" id="WarningMsgVideos">{{ msg.Videos }}</span>
                    </div>
                </div>

                <v-row class="mt-5" v-if="videoPreviews[0]">
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <v-card class="mx-auto">
                            <div style="position: relative;">
                                <video :src="videoPreviews[0].url" controls height="200"
                                    style="width: 100%; background-color: #f5f5f5;"></video>
                                <v-icon @click="removeVideo(0)" class="ml-2"
                                    style="color: red; position: absolute; top: 5px; right: 5px; cursor: pointer;">
                                    mdi-close-circle-outline
                                </v-icon>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-form>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
    getProductById,
    getAllSuppliersForProducts,
    getAllCategories,
    UpdateProductCatalog,
    isSupplier,
    idSupplier,
    getAllBrands,
    getAllProductTypes
} from "@/api"
import GenericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import chipsButton from '@/genericComponent/chipsButton.vue';
import autocompleteGrouped from '@/genericComponent/autocompleteGrouped.vue';
import uploadMultiDocument from "@/genericComponent/uploadMultiDocument.vue";
import uploadVideo from "@/genericComponent/uploadVideo.vue";
import { useI18n } from 'vue-i18n';
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const { t } = useI18n();
const route = useRoute()
// eslint-disable-next-line no-unused-vars
const router = useRouter()
const form = ref(null)
const loading = ref(false)
const productId = route.params.id
const MySupplier = ref(null)
const marks = ref([]);
const productType = ref([]);

const product = ref({
    id: '',
    name: '',
    description: '',
    basePrice: null,
    tax: null,
    productType: null,
    inventory: null,
    categories: [],
    tags: [],
    options: [],
    variants: [],
    variantsTo: [],
    images: [],
    videos: [],
    supplierId: null
})
const fileTypes = [{ mimeType: "image/jpeg", name: "JPEG" },
{ mimeType: "image/png", name: "PNG" },]
const imagePreviews = ref([])
const videoPreviews = ref([])
const suppliers = ref([])
const categories = ref([])
const newTag = ref('')
const removedImageIds = ref([])
const removedVideosIds = ref([])
const existingImages = ref([])
const existingVideos = ref([])
const msg = ref([])

const fetchMarks = async () => {
    try {
        const response = await getAllBrands(); // Fetch brands
        const brands = response.data;

        // Extract brand names for the autocomplete
        marks.value = brands.map(brand => ({
            brandName: brand.brandName,
            brandId: brand.brandId,
            logoUrl: brand.logoUrl // Optional: if you want to display logos
        }));
    } catch (error) {
        console.error('Error fetching brands:', error);
    }
};
const extractOptionsFromVariants = (variants) => {
    const optionsMap = new Map()

    variants.forEach(variant => {
        variant.options.forEach(option => {
            if (!optionsMap.has(option.name)) {
                optionsMap.set(option.name, new Set())
            }
            optionsMap.get(option.name).add(option.value)
        })
    })

    return Array.from(optionsMap.entries()).map(([name, values]) => ({
        name,
        values: Array.from(values)
    }))
}

const suggestedTags = ref([
    'New Arrival',
    'Best Seller',
    'Limited Edition',
    'Sale',
    'Premium',
    'Eco-friendly',
    'Handmade',
    'Custom',
    'Exclusive'
])

// Computed properties
const flattenedCategories = computed(() => {
    const flatten = (items, parentId = null) => {
        return items.reduce((acc, item) => {
            const flatItem = {
                ...item,
                parentCategoryId: parentId
            }
            acc.push(flatItem)
            if (item.children?.length) {
                acc.push(...flatten(item.children, item.categoryId))
            }
            return acc
        }, [])
    }
    return flatten(categories.value)
})


// Methods
const handleFileChange = async (files) => {
    // Clear existing new file previews but keep existing images
    imagePreviews.value = imagePreviews.value.filter(preview => preview.isExisting)
    //  product.value.images = files || [] // Store new files

    //  imagePreviews.value = []
    // if (!files) return
    if (!files) {
        // Don't clear existing images if no new files are selected
        product.value.images = []
        return
    }
    // Convert FileList to Array and append to existing files
    // const newFiles = Array.from(files);
    // Update product.images to include new files
    // product.value.images = [...(product.value.images || []), ...newFiles];

    const newFiles2 = product.value.images;
    for (const file of newFiles2) {
        try {
            const preview = await createImagePreview(file)
            imagePreviews.value.push({
                url: preview,
                name: file.name,
                size: file.size,
                file: file,
                isExisting: false,

            })
        } catch (error) {
            console.error('Error creating preview:', error)
        }
    }
}

const handleFileVideoChange = async (files) => {
    if (!files || files.length === 0) {
        product.value.videos = []
        videoPreviews.value = []
        return
    }

    const newFile = product.value.videos[0]

    try {
        const preview = await createImagePreview(newFile)
        videoPreviews.value = [
            {
                url: preview,
                name: newFile.name,
                size: newFile.size,
                file: newFile,
                isExisting: false,
            }
        ]
    } catch (error) {
        console.error('Error creating preview:', error)
    }
}

const createImagePreview = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (event) => {
            resolve(event.target.result)
        }

        reader.onerror = (error) => {
            reject(error)
        }

        reader.readAsDataURL(file)
    })
}

// Add function to remove image
const removeImage = (index) => {
    const preview = imagePreviews.value[index]

    if (preview.isExisting) {
        // If it's an existing image, add its ID to removedImageIds
        removedImageIds.value.push(preview.id)
        // Remove from existing images array
        existingImages.value = existingImages.value.filter(img => img.id !== preview.id)
    }

    // Remove from previews
    imagePreviews.value.splice(index, 1)

    // If it's a new image, remove from product.images
    if (!preview.isExisting) {
        const fileIndex = product.value.images.indexOf(preview.file)
        if (fileIndex > -1) {
            product.value.images.splice(fileIndex, 1)
        }
    }
}

const removeVideo = (index) => {
    const preview = videoPreviews.value[index]

    if (preview.isExisting) {
        removedVideosIds.value.push(preview.id)
        existingVideos.value = existingVideos.value.filter(vds => vds.id !== preview.id)
    }

    videoPreviews.value.splice(index, 1)

    if (!preview.isExisting) {
        const fileIndex = product.value.videos.indexOf(preview.file)
        if (fileIndex > -1) {
            product.value.videos.splice(fileIndex, 1)
        }
    }
}

function addTag() {
    const tag = newTag.value.trim()
    if (tag && !product.value.tags.includes(tag)) {
        product.value.tags.push(tag)
        newTag.value = ''
    }
    if (suggestedTags.value.includes(tag)) {
        const index = suggestedTags.value.findIndex((suggestedTag) => suggestedTag === tag);
        suggestedTags.value.splice(index, 1);
    }
}

function removeTag(index) {
    let tag = product.value.tags.at(index);
    product.value.tags.splice(index, 1);
    suggestedTags.value.push(tag);
}

const removeVariant = (index) => {
    product.value.variants.splice(index, 1);

    const warningIndex = variantWarning.value.indexOf(index);
    if (warningIndex !== -1) {
        variantWarning.value.splice(warningIndex, 1);
    }

    variantWarning.value = variantWarning.value.map(i => i > index ? i - 1 : i);
}

const fetchProductType = async () => {
    try {
        const response = await getAllProductTypes();
        const types = response.data;

        productType.value = types.map(brand => ({
            name: brand.name,
            id: brand.id,
        }));
    } catch (error) {
        console.error('Error fetching brands:', error);
    }
};

// onMounted 
onMounted(async () => {
    try {
        loading.value = true
        const [productData, categoriesResponse, suppliersResponse] = await Promise.all([
            getProductById(productId),
            getAllCategories(),
            getAllSuppliersForProducts()
        ])

        // Populate product data
        product.value = {
            ...productData.data,
            tax: productData.data.tax,
            basePrice: productData.data.basePrice,
            images: [],
            videos: [],
            // Ensure categories is an array of categoryIds
            categories: productData.data.categories.map(cat => cat.categoryId),
            variants: productData.data.variants.map(v => { v.manage_inventory = v.stock ? true : false; return v })

        }

        // Store existing images separately
        existingImages.value = productData.data.images || []

        // Generate image previews for existing images
        imagePreviews.value = existingImages.value.map(image => ({
            url: image.url,
            id: image.id,
            isExisting: true
        }))

        existingVideos.value = productData.data.videos || []
        videoPreviews.value = existingVideos.value.map(video => ({
            url: video.url,
            id: video.id,
            isExisting: true
        }))

        // Extract options from variants
        product.value.options = extractOptionsFromVariants(productData.data.variants)

        // Set categories and suppliers
        categories.value = categoriesResponse.data
        suppliers.value = suppliersResponse.data

        if (isSupplier()) {
            MySupplier.value = idSupplier();
            product.value.supplierId = MySupplier.value;
        }
        await fetchMarks();
        await fetchProductType();
    } catch (error) {
        console.error('Error fetching product data:', error)
    } finally {
        loading.value = false
    }
})

// addOption function
const addOption = () => {
    product.value.options.push({
        name: '',
        values: []
    })
}

// removeOption function
const removeOption = (index) => {
    product.value.options.splice(index, 1)
    generateVariants()
}

const hasValidOptions = computed(() => {
    return product.value.options.length > 0 &&
        product.value.options.every(option =>
            option.name &&
            option.values &&
            option.values.length > 0
        )
})

// Modified getVariantTitle function
const getVariantTitle = (variant) => {
    return variant.options
        .map(opt => `${opt.name}: ${opt.value}`)
        .join(' / ')
}

// generateVariants function
const generateVariants = () => {
    if (!hasValidOptions.value) return;

    const generateCombinations = (options, current = [], index = 0) => {
        if (index === options.length) {
            return [current];
        }

        const combinations = [];
        const option = options[index];

        for (const value of option.values) {
            combinations.push(
                ...generateCombinations(
                    options,
                    [...current, { name: option.name, value }],
                    index + 1
                )
            );
        }

        return combinations;
    };

    const areOptionsEqual = (opts1, opts2) => {
        if (opts1.length !== opts2.length) return false;
        return opts1.every((opt1) =>
            opts2.some((opt2) => opt1.name === opt2.name && opt1.value === opt2.value)
        );
    };

    const newCombinations = generateCombinations(product.value.options);
    const existingVariants = product.value.variants || [];

    const mergedVariants = [];

    for (const combination of newCombinations) {
        const existing = existingVariants.find((variant) =>
            areOptionsEqual(variant.options, combination)
        );

        if (existing) {
            mergedVariants.push(existing); // Keep the existing one
        } else {
            // Add new variant
            mergedVariants.push({
                id: "", // Will be assigned by backend
                priceAdjustment: 0,
                sku: `SKU${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
                stock: 0,
                collectionTimePerHour: 0,
                options: combination
            });
        }
    }

    product.value.variants = mergedVariants;
};

const variantWarning = ref([]);

const validateform = () => {
    msg.value["Supplier"] = "";
    msg.value["Categories"] = "";
    msg.value["Title"] = "";
    msg.value["Price"] = "";
    msg.value["Marque"] = "";
    msg.value["Tax"] = "";
    msg.value["Type"] = "";
    msg.value["Description"] = "";
    msg.value["Tags"] = "";
    msg.value["Variants"] = "";
    msg.value["Images"] = "";
    msg.value["Videos"] = "";

    if (!product.value.supplierId) {
        msg.value["Supplier"] = t('warningInput.isrequired', { itm: t('products.supplier') });
    } else {
        msg.value["Supplier"] = "";
    }

    if (!product.value.categories || product.value.categories == 0) {
        msg.value["Categories"] = t('warningInput.isrequired', { itm: t('products.categories') });
    } else {
        msg.value["Categories"] = "";
    }

    if (!product.value.name || product.value.name.length == 0) {
        msg.value["Title"] = t('warningInput.isrequired', { itm: t('products.title') });
    } else {
        msg.value["Title"] = "";
    }

    if (!product.value.basePrice || product.value.basePrice.length == 0) {
        msg.value["Price"] = t('warningInput.isrequired', { itm: t('products.price') });
    } else {
        msg.value["Price"] = "";
    }

    if (!product.value.marque) {
        msg.value["Marque"] = t('warningInput.isrequired', { itm: t('products.mark') });
    } else {
        msg.value["Marque"] = "";
    }

    if (product.value.tax.length == 0 || product.value.tax < 0) {
        msg.value["Tax"] = t('warningInput.isrequired', { itm: t('products.tax') });
    } else {
        msg.value["Tax"] = "";
    }

    if (!product.value.productType) {
        msg.value["Type"] = t('warningInput.isrequired', { itm: t('products.type') });
    } else {
        msg.value["Type"] = "";
    }

    if (!product.value.description || product.value.description.length == 0) {
        msg.value["Description"] = t('warningInput.isrequired', { itm: t('products.description') });
    } else {
        msg.value["Description"] = "";
    }

    if (!product.value.tags || product.value.tags.length == 0) {
        msg.value["Tags"] = t('warningInput.isrequired', { itm: t('products.tags') });
    } else {
        msg.value["Tags"] = "";
    }

    if (!product.value.variants || product.value.variants.length == 0) {
        msg.value["Variants"] = t('warningInput.isrequired', { itm: t('products.variants') });
    } else {
        // const invalidVariant = product.value.variants.find(variant =>
        //     variant.priceAdjustment <= 0 ||
        //     variant.quantityMinCommanded <= 0 ||
        //     variant.collectionTimePerHour < 0
        // );
        let invalidVariant = false;

        product.value.variants.forEach((variant, index) => {
            if (
                variant.priceAdjustment <= 0 ||
                variant.quantityMinCommanded <= 0 ||
                variant.collectionTimePerHour < 0
            ) {
                invalidVariant = true;
                variantWarning.value.push(index);
            }
        });

        if (invalidVariant) {
            msg.value["Variants"] = t('warningInput.wrong', { itm: t('products.variants') });
        } else {
            msg.value["Variants"] = "";
        }
    }

    if (existingImages.value.length +  product.value.images.length == 0) {
        msg.value["Images"] = t('warningInput.isrequired', { itm: t('products.images') });
    } else {
        msg.value["Images"] = "";
    }

    if (
        msg.value["Supplier"] == "" &&
        msg.value["Categories"] == "" &&
        msg.value["Title"] == "" &&
        msg.value["Price"] == "" &&
        msg.value["Marque"] == "" &&
        msg.value["Tax"] == "" &&
        msg.value["Type"] == "" &&
        msg.value["Description"] == "" &&
        msg.value["Tags"] == "" &&
        msg.value["Variants"] == "" &&
        msg.value["Images"] == ""
    ) {
        return true
    } else {
        ActiveWarningSnackBar();
        return false
    }
}

// updateProduct function
const updateProduct = async () => {
    if (!form.value.validate()) return

    if (!validateform()) return

    try {
        loading.value = true

        // Prepare the product data
        const productData = {
            ...product.value,
            basePrice: Number(product.value.basePrice),
            variants: product.value.variants.map(variant => ({
                //...variant,
                Id: variant.id !== "" ? variant.id : null,
                SKU: variant.sku,
                Options: variant.options.map(option => ({ Name: option.name, Value: option.value })),
                PriceAdjustment: Number(variant.priceAdjustment),
                Stock: Number(variant.stock),
                QuantityMinCommanded: Number(variant.quantityMinCommanded),
                CollectionTimePerHour: Number(variant.collectionTimePerHour)

            }))
        }


        // Prepare form data for multipart/form-data submission
        const formData = new FormData()
        // formData.append('data', JSON.stringify(productData))

        formData.append('Id', productData.id)
        formData.append('Name', productData.name)
        formData.append('Description', productData.description)
        formData.append('Variants', JSON.stringify(productData.variants))
        formData.append('BasePrice', productData.basePrice)
        formData.append('Tags', JSON.stringify(productData.tags))
        formData.append('CategoryIds', JSON.stringify(productData.categories))
        formData.append('SupplierId', productData.supplierId)
        formData.append('Tax', productData.tax);
        formData.append('Marque', productData.marque)
        formData.append('ProductType', productData.productType);

        // Add removed image IDs
        formData.append('RemovedImageIds', JSON.stringify(removedImageIds.value))

        // Add new images
        if (product.value.images?.length) {
            product.value.images.forEach(image => {
                if (image instanceof File) {
                    formData.append('NewImages', image)
                }
            })
        }

        if (removedVideosIds.value.length) {
            formData.append('RemovedVideosIds', JSON.stringify(removedVideosIds.value))
        }

        if (product.value.videos?.length) {
            product.value.videos.forEach(video => {
                if (video instanceof File) {
                    formData.append('NewVideos', video)
                }
            })
        }

        await UpdateProductCatalog(productId, formData)
        ActiveSavedSnackBar();
        // await router.push('/products')
    } catch (error) {
        ActiveWarningSnackBar();
        console.error('Error updating product:', error)
    } finally {
        loading.value = false;
        await router.push({ name: 'Products' });
    }
}

const setProductImages = (value) => {
    product.value.images.push(...value);
    handleFileChange(value)
}

const setProductVideo = (value) => {
    product.value.videos = [value];
    handleFileVideoChange(value)
}

const currency = computed(() => window.VUE_APP_CURRENCY);

function getParent(name) {
    let p = proxy.$parent;
    while (typeof p !== 'undefined') {
        if (p.$options.name === name) {
            return p;
        } else {
            p = p.$parent;
        }
    }
    return false;
}

function ActiveWarningSnackBar() {
    const parent = getParent('MainLayout');
    if (parent) parent.ActiveWarningSnackBar();
}

function ActiveSavedSnackBar() {
    const parent = getParent('MainLayout');
    if (parent) parent.ActiveSavedSnackBar();
}
</script>

<style scoped>
.v-card {
    border-radius: 8px;
}

.v-btn {
    text-transform: none;
}

.options-card {
    border: 1px solid #e0e0e0;
    margin-bottom: 16px;
}

.variant-table {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
}

.description-editor {
    border-radius: 4px;
}

.preview-content {
    min-height: 200px;
    white-space: pre-wrap;
    background-color: #f8f9fa;
}

.tags-container {
    border-radius: 4px;
}

.tags-input-container {
    max-width: 400px;
}

.tags-list {
    justify-content: center !important;
    align-items: center !important;
    min-height: 44px;
    border-radius: 4px;
}

.suggested-tags {
    padding-top: 8px;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}

:deep(.v-table) {
    background: transparent !important;
}

:deep(.v-table .v-table__wrapper > table) {
    padding: 0;
}

:deep(.v-table th) {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    background: #f5f5f5;
}

:deep(.v-table td) {
    padding: 8px 16px;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    color: blue;
}


:deep(.v-autocomplete--single .v-field--dirty:not(.v-field--focused) input) {
    opacity: 1 !important;
}
</style>
